import { t } from '@transifex/native';

import { flashes } from 'pkg/actions';
import * as endpoints from 'pkg/api/endpoints/auto';
import * as sdk from 'pkg/core/sdk';

export async function SkipTaskList(organizationId: number) {
	const req = await sdk.destroy(
		endpoints.TaskList.RemoveOrganizationOnboardingFlag(organizationId)
	);

	if (!req.ok) {
		flashes.show({ title: t('Something went wrong.') }, req.status);

		return false;
	}

	return true;
}
